import { formatClinicalTime } from '@features/components/ClinicalData/utils';
import { DateString } from '@/api/types';

const emptyTime = '--:--';

type ClinicalDataTimeLabelProps = {
  ocsTime?: DateString;
  timestamp?: DateString;
  timezone?: string;
  // orientation?: 'horizontal' | 'vertical'; // TODO: Add vertical variant
};

export const ClinicalDataTimeLabel = ({
  ocsTime,
  timestamp,
  timezone,
  /* , orientation = 'horizontal', */
}: ClinicalDataTimeLabelProps) => {
  if (!timestamp) {
    return (
      <div className="flex justify-between border-solid border rounded text-center">
        <div className="flex-1 min-w-16 bg-base-70">{emptyTime}</div>
        <div className="flex-1 min-w-16">{emptyTime}</div>
      </div>
    );
  }

  return (
    <div className="flex gap-2">
      <div className="flex items-center justify-between border rounded overflow-hidden">
        {!!ocsTime && ocsTime !== emptyTime && (
          <div className="flex items-center min-w-16 text-s-m text-base-80 bg-maroon-20 h-full px-2">OCS {ocsTime}</div>
        )}
        <div className="text-s-m min-w-16 px-2">{formatClinicalTime(timestamp, timezone)}</div>
      </div>
    </div>
  );
};
